import React, { useEffect, useState } from "react";
import "./sendEmailModal.css";
import BdrButton from "../../../../components/BdrButton/BdrButton";
import SendEmailModal from "./SendEmailModal";
import { lockBodyScroll, releaseBodyScroll } from "../../../../utils/bodyScrollLock";
// import { useSnackbar } from "../../../../utils/GlobalSnackbar/GlobalSnackbarContext";

const clearReplySubject = {
  subject: ""
}

/**
 * `icon` + `iconOnly` were added 2026-10-06 so this sits in the Emails
 * header as one of the action buttons rather than beside them in its own
 * style. The caller owns the collapse breakpoint — this component used to
 * decide at 600px while its CALLER swapped the label at a different width,
 * so the button could be showing an icon with a full-width button's chrome.
 * One source for the decision, passed in.
 */
const SendEmailOpenBtn = ({
  changeParentStyle,
  sendEmailBtnMes,
  sendTo,
  replySubject,
  icon,
  iconOnly = false,
  variant = "action",
}) => {
  // const { handleSnack } = useSnackbar();
  const [openSend, setOpenSend] = useState(false);
  const [replySub, setReplySub] = useState({...clearReplySubject});

  useEffect(() => {
    if (openSend === true) {
      if (replySubject) {
        setReplySub({
          subject: `Re: ${replySubject}`
        })
      }
    }
    if (openSend === false) {
      setReplySub({...clearReplySubject})
    }

    if (changeParentStyle) {
        changeParentStyle(openSend)
      }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openSend, replySubject]);

  /* The scroll lock is its OWN effect now. It used to share the one above,
     whose body also resets the reply subject and calls back into the parent —
     so the lock fired on every change of `replySubject`, not just on open. */
  useEffect(() => {
    if (!openSend) return undefined;
    lockBodyScroll();
    return () => releaseBodyScroll();
  }, [openSend]);

  const changeParentForEmailModal = (bool) => {
    setOpenSend(bool);
  };

  return (
    <>
      <BdrButton
        variant={variant}
        icon={icon}
        iconOnly={iconOnly}
        title="Send Email"
        ariaLabel="Send Email"
        onClick={(event) => {
          event.stopPropagation();
          setOpenSend(true);
        }}
      >
        {sendEmailBtnMes}
      </BdrButton>
      {openSend && (
        <SendEmailModal
          sendTo={sendTo}
          changeParent={changeParentForEmailModal}
          templateObj={replySub}
        />
      )}
    </>
  );
};

export default SendEmailOpenBtn;
